import React from 'react';
import * as css from './emptyState.module.scss';

export const EmptyState: React.FC<
  React.PropsWithChildren<{
    title: string;
    text: string;
  }>
> = ({ title, text }) => {
  return (
    <div className={css.emptyStateContainer} data-cy="empty-state">
      <div className={css.dashedSquareWithShadow}>
        <div className={css.shadow} />
        <div className={css.dashedSquare} />
      </div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
};
